import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AccessoryLocal } from '../../../shared/model/accessory-local';
import { NgRedux, select } from '@angular-redux/store';
import { ArgosState } from '../../../core/argos-state';
import { Observable } from 'rxjs/Observable';
import { PageInfo } from '../../../shared/model/page-info';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-accessory-local',
  templateUrl: './accessory-local.component.html',
  styleUrls: ['./accessory-local.component.css']
})
export class AccessoryLocalComponent implements OnInit {
  pageNumber = 0;
  pageSize = 5;
  nextDisabled = false;
  pageInfo: PageInfo;

  @Input() locals: Array<AccessoryLocal>;
  @Output() txOnSelectedLocal = new EventEmitter<AccessoryLocal>();
  @Output() txGetPage = new EventEmitter<any>();
  @select('freeAccessoriesTotal') freeAccessoriesTotal$: Observable<any>;

  nameFilter: any;
  filter = [];
  filterIsOpened = false;

  constructor(private ngRedux: NgRedux<ArgosState>,
              private _toastService: ToastService) {
  }

  ngOnInit() {
    this.findLocals();
  }

  selectLocal(local: AccessoryLocal) {
    if (this.ngRedux.getState().freeAccessoriesTotal === 0) {
      this.txOnSelectedLocal.emit(local);
    } else {
      this.showMessage('Finalize ou cancele a movimentação de acessórios.');
    }
  }

  previousPage() {
    if (this.pageNumber > 0) {
      this.pageNumber = this.pageNumber - 1;
      this.findLocals();
    }
  }

  nextPage() {
    if (!(this.locals.length === 0)) {
      this.pageNumber = this.pageNumber + 1;
      this.findLocals();
    }
  }

  goToPage(pageNumber) {
    this.pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
    this.findLocals();
  }

  findLocals() {
    this.sanitizeFilter();
    this.txGetPage.emit({pageNumber: this.pageNumber, pageSize: this.pageSize, localName: this.nameFilter});
  }

  openFilter() {
    this.filterIsOpened = true;
  }

  closeFilter() {
    this.pageNumber = 0;
    this.filterIsOpened = false;
    this.nameFilter = null;
    this.findLocals();
  }

  findByName() {
    this.pageNumber = 0;
    this.findLocals();
    this.filterIsOpened = false;
  }

  private showMessage(message: string) {
    this._toastService.showMessage(message, 4000);
  }

  private sanitizeFilter() {
    if (!this.nameFilter || this.nameFilter.length < 1) {
      this.nameFilter = null;
    }
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/accessory/component/accessory-local/accessory-local.component.ts